import { combineValidators } from "zeta-dom-react";
import { translate as t } from "src/i18n";

export interface ValidatorProps {
    label?: string;
    getErrorMessage?: (validator: 'required' | 'pattern') => string | undefined;
}

export { combineValidators as combine }

export function required<T = string>() {
    return (value: T) => {
        return value ? '' : ((props: ValidatorProps) => props.getErrorMessage?.('required') || t('common.validation.required'));
    };
}

export function pattern(pattern1: string) {
    return (value: string) => {
        return new RegExp(`^${pattern1}$`).test(value) ? '' : ((props: ValidatorProps) => props.getErrorMessage?.('pattern') || t('common.validation.incorrectFormat'));
    };
}
